module.exports = __webpack_public_path__ + "img/et-present.d9bab8b4.webp";